import { useBudgetOnboardingContext } from '@/components/cashflow/budget/BudgetOnboardingContext';
import { BudgetOnboardingLayout } from '@/components/cashflow/budget/BudgetOnboardingLayout';
import { FlexCol } from '@/components/common/Flex';
import PlentySpinner from '@/components/common/PlentySpinner';
import { Paragraph, Subheader } from '@/components/common/Typography';
import { Box } from '@chakra-ui/react';
import {
    TRANSACTION_SYNCING_TEXT,
    useTransactionsSyncState,
} from '@common/react/budget';

export const BudgetOnboardingTransactionsSyncing = () => {
    const state = useTransactionsSyncState();
    const { goToNextStep } = useBudgetOnboardingContext();

    return (
        <BudgetOnboardingLayout
            onContinue={goToNextStep}
            isContinueDisabled={state === 'loading'}
            isSubmitting={false}
            buttonText="Continue"
            onClickEvent="Budget Transaction Sync View Continue Button Clicked"
            onClickEventParams={{ state }}
        >
            <Box h={400}>
                <PlentySpinner
                    message={
                        <FlexCol gap={5}>
                            <Subheader>
                                {TRANSACTION_SYNCING_TEXT[state].title}
                            </Subheader>
                            <Paragraph>
                                {TRANSACTION_SYNCING_TEXT[state].subtitle}
                            </Paragraph>
                        </FlexCol>
                    }
                    showAnimation={state === 'loading' || state === 'timeout'}
                />
            </Box>
        </BudgetOnboardingLayout>
    );
};
